import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2, Search, Home } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";

export default function ManageLookup() {
  const navigate = useNavigate();
  const [code, setCode] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/manage/lookup", { code: code.trim(), email: email.trim() });
      navigate(`/manage/${data.token}`);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-cream pt-24 pb-16 px-5">
      <div className="max-w-md mx-auto">
        <Link to="/" className="inline-flex items-center gap-1 text-sm text-stone-500 hover:text-rose mb-5">
          <Home size={15} /> The Rose Air BnB
        </Link>
        <div className="card-lux p-8" data-testid="manage-lookup">
          <span className="eyebrow">Manage My Booking</span>
          <h1 className="font-serif text-3xl text-forest mt-2">Find your reservation</h1>
          <p className="text-stone-500 text-sm mt-2">
            Enter the booking code from your confirmation email along with the email you booked with.
          </p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <label className="text-xs uppercase tracking-wide text-stone-500">Booking code</label>
              <input
                required value={code} onChange={(e) => setCode(e.target.value)}
                placeholder="e.g. RA-7F3K2A" data-testid="lookup-code"
                className="mt-1 w-full rounded-lg border border-stone-200 px-4 py-3 text-sm uppercase focus:outline-none focus:ring-2 focus:ring-rose/30"
              />
            </div>
            <div>
              <label className="text-xs uppercase tracking-wide text-stone-500">Email address</label>
              <input
                required type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com" data-testid="lookup-email"
                className="mt-1 w-full rounded-lg border border-stone-200 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-rose/30"
              />
            </div>
            <button type="submit" disabled={loading} data-testid="lookup-submit" className="btn-primary w-full disabled:opacity-60">
              {loading ? <Loader2 className="animate-spin" size={16} /> : <><Search size={16} /> Find my booking</>}
            </button>
          </form>
          <p className="text-xs text-stone-400 mt-5">
            Can't find your code? <Link to="/contact" className="text-rose font-semibold">Contact us</Link> and we'll help.
          </p>
        </div>
      </div>
    </div>
  );
}
